import TYPES from "../constants";
import { REHYDRATE } from "redux-persist";

const initialState = {
  error: null,
  deleteUserId: null,
  loading: false,
  deleteUserInfo: {},
  currentVendorRowData: {},
  editCycleData: [],
  cycleDataById: {},
  historyData: []
};

const deleteParticularVendor = (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE:
      {
          const persistedAuthState = action.payload?.deleteParticularVendor || {};
          return {
            ...state,
            ...persistedAuthState,
            loading: false, // Reset loading to false
            error: null,    // reset error
          };
      }
    case TYPES.GET_VENDOR_EDIT_CYCLE_LOADING: 
    case TYPES.GET_VENDOR_EDIT_CYCLE_DATA_BY_ID_LOADING:
    case TYPES.GET_VENDOR_HISTORY_EXPORT_LOADING:
    return {
      ...state,
      loading:true,
      error: null
    }
    case TYPES.DELETE_VENDOR:
      return {
        ...state,
        loading: true,
      };
    case TYPES.DELETE_VENDOR_SUCCESS:
      return {
        ...state,
        deleteUserInfo: action.payload,
        loading: false,
        error: null,
      };
    case TYPES.GET_VENDOR_EDIT_CYCLE_SUCCESS:
      return {
        ...state,
        editCycleData: action.payload,
        loading: false,
        error: null
      } 
    case TYPES.GET_VENDOR_EDIT_CYCLE_DATA_BY_ID_SUCCESS: 
    return {
      ...state,
      cycleDataById: action.payload,
      loading: false,
      error: null
    }
    case TYPES.GET_VENDOR_HISTORY_EXPORT_SUCCESS:
      return {
        ...state,
        historyData: action.payload,
        loading: false,
        error: null
      }
    case TYPES.DELETE_VENDOR_FAILURE:
    case TYPES.GET_VENDOR_EDIT_CYCLE_FAILURE:
    case TYPES.GET_VENDOR_EDIT_CYCLE_DATA_BY_ID_FAILURE:
    case TYPES.GET_VENDOR_HISTORY_EXPORT_FAILURE:  
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case TYPES.CURRENT_VENDOR_ROW_DATA:
      return {
        ...state,
        currentVendorRowData: action.payload,
        error: null,
        loading: false,
      };
    default:
      return state;
  }
};

export default deleteParticularVendor;
